export default {"src":"/_next/static/media/hotel.9ca2f6f8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};